module.exports = __webpack_public_path__ + "assets/img/thumb-Found-Concrete-Video.f6d2cf8c.jpg";